import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles/app.css'

const wortel = document.getElementById('wortel')
if (!wortel) throw new Error('Het element #wortel staat niet in index.html')

createRoot(wortel).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
